// extracted by mini-css-extract-plugin
export default {"show-more-button":"rHOmY","showMoreButton":"rHOmY","show-more-button-large":"QVkPO","showMoreButtonLarge":"QVkPO"};